import NumericSmoking from "./NumericSmoking";
export * from "./NumericSmoking";
export default NumericSmoking;
